import { httpClient } from "@/app/client/httpClient";
import { captureException } from "@/plugins/sentry";

class VersionService {
  // アプリの利用要件をみたいしているかどうかチェック
  // true=満たしている
  async isMeetRequirements(): Promise<boolean> {
    try {
      // @ts-ignore
      if (!window.cordova) return true; // cordovaがいない（Web画面）の場合はtrueを返す

      // @ts-ignore
      const currentVersion = await cordova.getAppVersion.getVersionNumber();
      const { minimumVersion } = await httpClient.versions.$get();
      return this.compareVersion(currentVersion, minimumVersion) >= 0;
    } catch (e) {
      captureException(e as Error);
      // 例外が発生したときは満たしていると仮定する
      return true;
    }
  }

  /**
   * AとBでバージョンを比較する
   * Aの方が大きければ1,Bの方が大きければ-1,同じであれば0を返す
   * @param versionStrA
   * @param versionStrB
   */
  compareVersion(versionStrA: string, versionStrB: string) {
    const [majorA, minorA, patchA] = this.splitVersions(versionStrA);
    const [majorB, minorB, patchB] = this.splitVersions(versionStrB);

    if (majorA > majorB) return 1;
    if (majorA < majorB) return -1;

    if (minorA > minorB) return 1;
    if (minorA < minorB) return -1;

    if (patchA > patchB) return 1;
    if (patchA < patchB) return -1;

    return 0;
  }

  splitVersions(versionString: string) {
    return versionString.split(".").map(v => Number(v));
  }
}

export const versionService = new VersionService();
